import { Slide, SlideProps } from "@mui/material";
import { forwardRef } from "react";

type SlideDirection = "up" | "down" | "left" | "right";

const createSlideTransition = (direction: SlideDirection) =>
  forwardRef<HTMLDivElement, SlideProps>((props, ref) => {
    return (
      <Slide
        direction={direction}
        ref={ref}
        {...props}
        timeout={{ enter: 700, exit: 600 }}
      />
    );
  });

export const SlideTransitionUp = createSlideTransition("up");
export const SlideTransitionDown = createSlideTransition("down");
export const SlideTransitionLeft = createSlideTransition("left");
export const SlideTransitionRight = createSlideTransition("right");
